import { Model } from '@/models/Model';
export class SchoolLog extends Model {
    constructor() {
        super(...arguments);
        this.$endpoint = '/school-logs';
        this.$name = 'SchoolLog';
        this.$fillable = [];
        // #endregion
        // #region Getters & Setters
        // #endregion
    }
    // #region relationship methods
    // #endregion
    // #region Endpoints
    // #endregion
    // #region Class methods
    include(include) {
        return super.include(include);
    }
    // HERE need to pick the keys coming back from the API.
    async all() {
        // return response.map(res => new SchoolLog(res)) as any
        return super.all();
    }
    filter(filters, value) {
        return super.filter(filters, value);
    }
    update(payload) {
        return super.update(payload);
    }
    create(payload) {
        return super.create(payload);
    }
}
// #region Includes enum
export var NoteIncludesEnum;
(function (NoteIncludesEnum) {
    NoteIncludesEnum["USER"] = "user";
})(NoteIncludesEnum || (NoteIncludesEnum = {}));
// type RecursivePartial<T> = {
//     [P in keyof T]?: RecursivePartial<T[P]>;
// };
// type PartialExcept<T, K extends keyof T> = RecursivePartial<T> & Pick<T, K>;
const response = [
    {
        id: '96900fb0-3f96-4219-ac69-9ac0fa106a37',
        action: 'model:setting',
        message: 'This setting has been updated: hide_my_roster with this value: ',
        created_at: '2022-06-17 10:33:46',
        updated_at: '2022-06-17 10:33:46',
        user: {
            id: '8b86716c-4ab2-4d97-8a34-2468fc619be0',
            name: 'Samir Root',
            first_name: 'Samir',
            middle_name: '',
            last_name: 'Root',
            email: 'samir@scoolsuite.com',
            dob: '1991-05-27',
            phone: '',
            avatar: 'https://www.gravatar.com/avatar/4abc20a5d9266286188541f37aa19cdb?d=identicon&s=128',
            has_mfa_token: true,
            mfa_required: false,
            created_at: '2018-08-12 19:37:28',
            updated_at: '2021-12-09 16:14:07',
            links: {
                self: 'http://grondtoon.staging-api.scoolorganizer.com/v3/users/8b86716c-ff9b-4183-8821-42ddc7d0136b',
            },
        },
    },
    {
        id: '968fc356-4615-42a4-b07e-581179d6473d',
        action: 'model:user',
        message: 'This user: Marjolein Bos - Schouten Van Der Velden has been updated.',
        created_at: '2022-06-17 07:00:17',
        updated_at: '2022-06-17 07:00:17',
        user: null,
    },
    {
        id: '968fc356-4d79-49a0-b893-1d18f71feff6',
        action: 'model:user',
        message: 'This user: Juf Aline Dijkema has been updated.',
        created_at: '2022-06-16 07:00:17',
        updated_at: '2022-06-17 07:00:17',
        user: null,
    },
    {
        id: '968fc356-574f-43f7-b1e0-39cd5faa526c',
        action: 'model:user',
        message: 'This user: Daniëlle van Driel has been updated.',
        created_at: '2022-06-16 07:00:17',
        updated_at: '2022-06-17 07:00:17',
        user: null,
    },
    {
        id: '968fc356-5a65-4431-851d-dfe21199eb02',
        action: 'model:user',
        message: 'This user: Cor Duijst has been updated.',
        created_at: '2022-06-15 07:00:17',
        updated_at: '2022-06-17 07:00:17',
        user: null,
    },
    {
        id: '968fc356-6468-443b-87ca-9f450807b86e',
        action: 'model:user',
        message: 'This user: Ilse van \'t Ende has been updated.',
        created_at: '2022-06-15 07:00:17',
        updated_at: '2022-06-17 07:00:17',
        user: null,
    },
    {
        id: '968fc356-684a-4c62-9ba3-e98e1afd7b21',
        action: 'model:user',
        message: 'This user: Derek de Graaf has been updated.',
        created_at: '2022-06-15 07:00:17',
        updated_at: '2022-06-17 07:00:17',
        user: null,
    },
    {
        id: '968fc356-71de-4d16-ad1f-5cac772f7a53',
        action: 'model:user',
        message: 'This user: Dirk-Jan den Graaf has been updated.',
        created_at: '2022-06-17 07:00:17',
        updated_at: '2022-06-17 07:00:17',
        user: null,
    },
    {
        id: '968fc356-7bfc-480b-bfe0-ff61f4f605ed',
        action: 'model:user',
        message: 'This user: Maralie de Graaf has been updated.',
        created_at: '2022-06-17 07:00:17',
        updated_at: '2022-06-17 07:00:17',
        user: null,
    },
    {
        id: '968fc356-80a0-4c19-9142-c0e33a8e145d',
        action: 'model:user',
        message: 'This user: Willemijne de Graaf has been updated.',
        created_at: '2022-06-17 07:00:17',
        updated_at: '2022-06-17 07:00:17',
        user: null,
    },
    {
        id: '968fc356-842b-40bb-9bb6-e460ca0c50ee',
        action: 'model:user',
        message: 'This user: Eefje Heinen has been updated.',
        created_at: '2022-06-17 07:00:17',
        updated_at: '2022-06-17 07:00:17',
        user: null,
    },
    {
        id: '968fc356-8a81-41f5-8345-e8d2b75c1047',
        action: 'model:user',
        message: 'This user: Invaller Invaller De Grondtoon has been updated.',
        created_at: '2022-06-17 07:00:17',
        updated_at: '2022-06-17 07:00:17',
        user: null,
    },
    {
        id: '968fc356-8eab-4cd9-a405-d82f083750f1',
        action: 'model:user',
        message: 'This user: Carola Koelewijn has been updated.',
        created_at: '2022-06-17 07:00:17',
        updated_at: '2022-06-17 07:00:17',
        user: null,
    },
    {
        id: '968fc356-97e7-4a53-ad5d-c7e922d9654e',
        action: 'model:user',
        message: 'This user: Marenke Kroon-Bouwman has been updated.',
        created_at: '2022-06-17 07:00:17',
        updated_at: '2022-06-17 07:00:17',
        user: null,
    },
    {
        id: '968fc356-a110-4d8c-89b8-67547d69da60',
        action: 'model:user',
        message: 'This user: Mathilde Muijs has been updated.',
        created_at: '2022-06-17 07:00:17',
        updated_at: '2022-06-17 07:00:17',
        user: null,
    },
];
